import { translate, hasTranslation } from '@fiverr-private/i18n-react';

type TranslateOptions = Parameters<typeof translate>['1'];

export interface SafeTranslateOptions {
    /**
     * Keys to be translated.
     */
    key: string | string[];
    /**
     * Translation utility options.
     */
    translateOptions?: TranslateOptions;
    /**
     * Will return fallback if key has no translation.
     */
    fallback?: string;
    /**
     * Will return fallback translation if key has no translation, has a priority over fallback if passed both.
     */
    fallbackKey?: string | string[];
    /**
     * Translation utility options for fallback key.
     */
    fallbackOptions?: TranslateOptions;
}

/**
 * Safe translate wrapper. If translation is missed will return a fallback.
 */
export const safeTranslate = ({
    key,
    translateOptions,
    fallback,
    fallbackKey,
    fallbackOptions,
}: // TODO: remove type cast on return value when `translate` will be typed
SafeTranslateOptions): string => {
    if (hasTranslation(key)) {
        return translate(key, translateOptions);
    }

    if (typeof fallbackKey === 'string') {
        return translate(fallbackKey, fallbackOptions);
    }

    if (typeof fallback === 'string') {
        return fallback;
    }

    return translate(key, translateOptions);
};
